import moment from 'moment';

export const formatDashboardApiDate = (date, boundary = 'start') => {
  const m = moment(date).utc();
  if (boundary === 'end') {
    return m.endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
  }
  return m.startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
};

export const getDefaultDashboardDateRange = () => ({
  start: moment().subtract(30, 'days').startOf('day').toDate(),
  end: moment().endOf('day').toDate()
});

export const graphToChartData = (graph = []) => {
  const data = {};
  graph.forEach(({ Date, Count }) => {
    data[moment(Date).format('MM/DD')] = Count ?? 0;
  });
  return data;
};

export const toDashboardQueryDates = ({ start, end }) => ({
  startDate: formatDashboardApiDate(start, 'start'),
  endDate: formatDashboardApiDate(end, 'end')
});

export const toDashboardQueryParams = (dateRange, locationGuid = '') => ({
  ...toDashboardQueryDates(dateRange),
  ...(locationGuid ? { locationGuid } : {})
});
